<template>
  <div>
    <h1>Button 按钮</h1>
    <p class="page-desc">按钮用于开始一个即时操作。</p>

    <k-row gutter="16">
      <k-col span="24" :xl="{ span: 12 }">
        <demo-viewer
          title="基础用法"
          :code="JCYF"
          desc="可点击按钮触发业务逻辑"
        >
          <k-button>按钮</k-button>
          <k-divider type="vertical" />
          <k-button style="width:100px;">按钮</k-button>
        </demo-viewer>

        <demo-viewer
          title="圆角及图标"
          :code="YJJTB"
          desc="当需要在 按钮 内嵌入 Icon 时，可以设置 icon 属性，或者直接在 按钮 内使用 k-icon 组件。"
        >
          <p>
            <k-button icon="delete">删除</k-button>
            <k-divider type="vertical" />
            <k-button icon="delete" />
          </p>
          <p>
            <k-button icon="search" circle>查询</k-button>
            <k-divider type="vertical" />
            <k-button circle icon="search" />
          </p>
        </demo-viewer>

        <demo-viewer
          title="长按钮"
          :code="CNN"
          desc="long 属性将使按钮适合其父宽度。"
        >
          <k-button long circle>提交</k-button>
          <p>
            <k-button long>提交</k-button>
          </p>
        </demo-viewer>
      </k-col>
      <k-col span="24" :xl="{ span: 12 }">
        <demo-viewer
          title="加载状态"
          :code="JZZT"
          desc="添加 loading 属性即可让按钮处于加载状态。"
        >
          <p>
            <k-button loading>加载中</k-button>
            <k-divider type="vertical" />
            <k-button loading />
            <k-divider type="vertical" />
            <k-button :loading="loading" @click="toLoading">提交</k-button>
          </p>
          <p>
            <k-button loading circle>加载中</k-button>
            <k-divider type="vertical" />
            <k-button loading circle />
            <k-divider type="vertical" />
            <k-button :loading="loading2" @click="toLoading2" circle
              >提交</k-button
            >
          </p>
        </demo-viewer>

        <demo-viewer
          title="禁用状态"
          :code="JYZT"
          desc="添加 disabled 属性即可让按钮处于不可用状态。"
        >
          <k-button disabled>不可用</k-button>
          <k-divider type="vertical" />
          <k-button icon="save" disabled>保存</k-button>
          <k-divider type="vertical" />
          <k-button icon="save" disabled />
        </demo-viewer>

        <demo-viewer
          title="按钮类型"
          :code="ANLX"
          desc="通过设置type为default、primary、danger创建不同样式的按钮，不设置为默认样式。"
        >
          <k-button type="default">默认按钮</k-button>
          <k-divider type="vertical" />
          <k-button type="primary">主要按钮</k-button>
          <k-divider type="vertical" />
          <k-button type="danger">危险按钮</k-button>
        </demo-viewer>
      </k-col>
    </k-row>

    <demo-viewer
      title="按钮组"
      :code="ANZ"
      desc="以按钮组的方式出现，常用于多项类似操作。"
    >
      <p>
        <k-button-group>
          <k-button icon="caret-left">上一页</k-button>
          <k-button>下一页 <k-icon type="caret-right"/></k-button>
        </k-button-group>
        <k-divider type="vertical" />
        <k-button-group>
          <k-button icon="appstore-fill" />
          <k-button icon="edit-fill" />
          <k-button icon="save-fill" />
          <k-button disabled icon="setting-fill" />
        </k-button-group>
      </p>

      <p>
        <k-button-group circle>
          <k-button icon="left">上一页</k-button>
          <k-button>下一页 <k-icon type="right"/></k-button>
        </k-button-group>
        <k-divider type="vertical" />
        <k-button-group circle>
          <k-button icon="appstore" />
          <k-button icon="edit" />
          <k-button disabled icon="save" />
          <k-button icon="setting" />
        </k-button-group>
      </p>
      <p>
        <k-button-group>
          <k-button icon="home-fill" />
          <k-button>Menu</k-button>
          <k-button>About</k-button>
          <k-button>Services</k-button>
          <k-button>Portfolio</k-button>
          <k-button>Contact</k-button>
        </k-button-group>
      </p>
    </demo-viewer>

    <table class="doc-table">
      <caption>
        <h3>属性 props</h3>
      </caption>
      <thead>
        <tr>
          <th>参数</th>
          <th>说明</th>
          <th>类型</th>
          <th>默认值</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>type</td>
          <td>按钮类型，可选值为 default、primary、danger或者不设置</td>
          <td>String</td>
          <td>default</td>
        </tr>
        <tr>
          <td>icon</td>
          <td>设置按钮的图标类型</td>
          <td>String</td>
          <td>-</td>
        </tr>
        <tr>
          <td>circle</td>
          <td>开启后,按钮形状将调整为圆角</td>
          <td>Boolean</td>
          <td>false</td>
        </tr>
        <tr>
          <td>long</td>
          <td>开启后,按钮宽度将调整为其父宽度</td>
          <td>Boolean</td>
          <td>false</td>
        </tr>
        <tr>
          <td>loading</td>
          <td>设置按钮载入状态</td>
          <td>Boolean</td>
          <td>false</td>
        </tr>
        <tr>
          <td>disabled</td>
          <td>按钮失效状态</td>
          <td>Boolean</td>
          <td>false</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      loading2: false,
      JCYF: `
  <template>
    <k-button>按钮</k-button>
    <k-button style="width:100px;">按钮</k-button>
  </template>
      `,
      YJJTB: `
  <template>
    <k-button icon="delete">删除</k-button>
    <k-button icon="delete" />

    <k-button icon="search" circle>查询</k-button>
    <k-button circle icon="search" />
  </template>
      `,
      CNN: `
  <template>
    <k-button long>提交</k-button>
  </template>
      `,
      JZZT: `
  <template>
    <k-button loading>加载中</k-button>
    <k-button loading />

    <k-button loading circle>加载中</k-button>
    <k-button loading circle />
  </template>
      `,
      JYZT: `
  <template> 
    <k-button disabled>不可用</k-button>
    <k-button icon="save" disabled>保存</k-button>
    <k-button icon="save" disabled />
  </template>
      `,
      ANZ: `
  <template>
    <k-button-group>
      <k-button icon="caret-left">上一页</k-button>
      <k-button>下一页 <k-icon type="caret-right"/></k-button>
    </k-button-group>
    
    <k-button-group>
      <k-button icon="appstore-fill" />
      <k-button icon="edit-fill" />
      <k-button icon="save-fill" />
      <k-button disabled icon="setting-fill" />
    </k-button-group>
  
    <k-button-group circle>
      <k-button icon="left">上一页</k-button>
      <k-button>下一页 <k-icon type="right"/></k-button>
    </k-button-group>
    
    <k-button-group circle>
      <k-button icon="appstore" />
      <k-button icon="edit" />
      <k-button disabled icon="save" />
      <k-button icon="setting" />
    </k-button-group>
  
    <k-button-group>
      <k-button icon="home-fill" />
      <k-button>Menu</k-button>
      <k-button>About</k-button>
      <k-button>Services</k-button>
      <k-button>Portfolio</k-button>
      <k-button>Contact</k-button>
    </k-button-group>
  </template>
      `,
      ANLX: `
  <template> 
    <k-button type="default">默认按钮</k-button>
    <k-button type="primary">主要按钮</k-button>
    <k-button type="danger">危险按钮</k-button>
  </template>
      `
    };
  },
  methods: {
    toLoading() {
      this.loading = true;
    },
    toLoading2() {
      this.loading2 = true;
    }
  }
};
</script>
<style lang="less" scoped></style>
